// ===== QUOTE PRICING STATUS ENUMS =====

export enum QuotePricingStatusEnum {
  "Active" = 1,
  "Inactive" = 2,
  "Draft" = 3,
  "Archived" = 4,
}